import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
const Home = React.lazy(() => import("./pages/Home"));
const SignIn = React.lazy(() => import("./pages/SignIn"));
const SignUp = React.lazy(() => import("./pages/SignUp"));
const Layout = React.lazy(() => import("./components/Layout"));
const Privacy = React.lazy(() => import("./pages/Privacy"));
const Terms = React.lazy(() => import("./pages/Terms"));
const AboutUs = React.lazy(() => import("./pages/AboutUs"));
const ContactUs = React.lazy(() => import("./pages/Contact"));
const Shipping = React.lazy(() => import("./pages/Shipping"));
const FAQ = React.lazy(() => import("./pages/FAQ"));
const Features = React.lazy(() => import("./pages/Features"));
const Pricing = React.lazy(() => import("./pages/Pricing"));
const RefundPolicy = React.lazy(() => import("./pages/Refund"));
const PracticeConfiguration = React.lazy(() => import("./pages/PracticeConfiguration"));
const PracticePaper = React.lazy(() => import("./pages/PracticePaper"));
const PracticeTest = React.lazy(() => import("./pages/PracticeTest"));

const DashboardLayout = React.lazy(() => import("./components/Dashboard"));
const Chat = React.lazy(() => import("./pages/Chat"));
const TestGenerator = React.lazy(() => import("./pages/Generator"));
const Checkout = React.lazy(() => import('./pages/Checkout'))

ReactGA.initialize("G-DHY78SG8ZJ");

function AnalyticsTracker() {
	const location = useLocation();
	React.useEffect(() => {
		ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
	}, [location]);
	return null;
}

const App = () => (
	<AuthProvider>
		<BrowserRouter>
			<AnalyticsTracker />
			<Routes>
				<Route index path="/sign-up" element={<SignUp />} />
				<Route element={<Layout />}>
					<Route index path="/" element={<Home />} />
					<Route index path="/login" element={<SignIn />} />
					{/* <Route path="/blog" element={<Blog />} /> */}
					<Route index path="/privacy" element={<Privacy />} />
					<Route index path="/refund-policy" element={<RefundPolicy />} />
					<Route index path="/terms" element={<Terms />} />
					<Route index path="/about-us" element={<AboutUs />} />
					<Route index path="/contact-us" element={<ContactUs />} />
					<Route index path="/shipping-policy" element={<Shipping />} />
					<Route index path="/faqs" element={<FAQ />} />
					<Route index path="/features" element={<Features />} />
					<Route index path="/pricing" element={<Pricing />} />
					<Route path="*" element={<ProtectedRoute />} />
				</Route>
				<Route element={<ProtectedRoute />}>
					<Route index path="/checkout" element={<Checkout />} />
					<Route element={<DashboardLayout />}>
						<Route path="/chat" element={<Chat />} />
						<Route path="/practice/configuration" element={<PracticeConfiguration />} />
						<Route path="/practice/test/:id" element={<PracticeTest />} />
						<Route path="/practice/paper/:id" element={<PracticePaper />} />
						<Route path="/test-generator" element={<TestGenerator />} />
					</Route>
				</Route>
			</Routes>
		</BrowserRouter>
	</AuthProvider>
);

export default App;